import Introduction1 from "assets/common/company/introduction1.png";
import Introduction2 from "assets/common/company/introduction2.png";
import IntroDetail1 from "assets/common/company/introDetail1.png";
import IntroDetail2 from "assets/common/company/introDetail2.png";
import IntroDetail3 from "assets/common/company/introDetail3.png";
import IntroDetail4 from "assets/common/company/introDetail4.png";

const Introduction = () => {
    return (
        <div className="flex-1 bg-[#f4f4f4] flex flex-col items-center pb-16 pt-5 responsive1200:px-[4%] responsive1200:pt-0">
            <p className="py-[35px] text-[#333] text-[28px] font-[500] responsive1200:py-[30px] responsive1200:text-[24px]">
                회사소개 / CEO 인사말
            </p>
            <div className="bg-white w-full max-w-[1200px] p-[50px] responsive1200:px-[4%] responsive1200:py-[10%]">
                <div className="flex items-center responsive1200:flex-col responsive1200:items-start">
                    <div className="relative responsive1200:w-full responsive1200:mb-[45px]">
                        <div className="bg-[#f4f4f4] w-full h-full absolute top-0 right-0 translate-y-[20px] max-w-[calc(100%-20px)]" />
                        <img src={Introduction1} alt="introduction1" className="z-10 relative animate-fade-in w-[calc(100%-20px)]" />
                    </div>
                    <img
                        src={Introduction2}
                        alt="Is Different! ILSHIN Different! (주)일신항공해운, 일신모닝택배, 일신모닝퀵, 일신모닝특송. 목적지는 같아도 서비스는 다릅니다. 이제 저렴하고, 빠르고, 정확한 일신그룹과 함께 하십시오"
                        className="ml-20 responsive1200:ml-0"
                    />
                </div>

                <p className="mt-16 text-[#333] leading-7  responsive1200:text-[14px] responsive1200:mt-[20px]">
                    <span className="text-[#1744ad] font-[500]">
                        저희 ㈜일신항공해운 / 일신모닝택배 / 일신모닝퀵 / 일신모닝특송은 1992년 창립 이래 OSC(OVERNIGHT SERVICE COMPANY)의
                        경영 이념(최고 최선의 기업 / 삶의 생활기업 / 세계선교기업)을 기반으로,
                    </span>
                    <span>
                        오직 고객만족만을 최우선의 목표로 삼아 국제특송 및 항공화물, 전시화물, 국내모닝택배 및 모닝퀵서비스를 전문으로
                        발전하여온, 국내 동업계의 선도적 기업으로서 LA, NY, 독일, 영국, 프랑스, 폴란드, 상해, 광주, 홍콩, 베트남, 두바이,
                        제다 등 세계 주요 도시의 지사와 파트너를 통해 전세계를 대상으로 한
                    </span>
                    <span className="text-[#1744ad] font-[500]">
                        오늘날 국제 물류의 대표적 주류 인 DOOR TO DOOR SERVICE를 완벽하게 실현
                    </span>
                    <span>
                        하고 있으며, 본사 물류센터(행주외동), 경기북부 물류센터(양주), 동부물류센터(하남), 남부 물류센터(안산), 서부
                        물류센터(부천), 대구 물류센터(이현동), 부산물류센터(대저동) 등 전국 주요 도시의 물류센터를 통해 서울과 경기 수도권,
                        대구, 전주, 부산 등 전국 모든지역에 기업택배 서비스와 더불어, 특히 서울과 경기 그리고 대구, 부산지역에는
                    </span>
                    <span className="text-[#1744ad] font-[500]">
                        출근 전 당일배송 시스템인 'SMS서비스(모닝택배서비스)'와 긴급배송을 요하는 급송서비스인 ‘모닝퀵서비스’를 완벽하게
                        제공해드리고 있습니다.
                    </span>
                    <br /> <br />
                    <span>특히, 창립 이래 해마다 국내와 해외에서 개최되는 </span>
                    <span className="text-[#1744ad] font-[500]">
                        각종 전시회, 박람회의 참가물품을 전문으로 취급해옴으로써 전시운송분야에 대한 최고수준의 경험과 노하우를 축적
                    </span>
                    <span>
                        하여, 국내 수출입 및 내수업체의 성공적인 영업을 물심양면으로 지원하여 왔습니다. 이외에도 새로운 지역, 다양한 서비스
                        상품개발에 주력하여 국내외 한 차원 높은 서비스를 저렴한 가격에 제공하고 있음은 물론,
                    </span>
                    <span className="text-[#1744ad] font-[500]">전세계 어느 지역을 막론하고 가장 정확하고 신속한 서비스를 보장</span>
                    <span>
                        해드립니다. <br /> <br /> 앞으로도 저희 (주)일신그룹은 수출입 및 내수업체의 성공적인 미래를 위한 가장 충실한
                        파트너로서 언제나 여러분 곁에 자리매김 할것을 약속 드립니다.
                    </span>
                </p>
                <p className="mt-10 text-[#333] flex items-center justify-end responsive1200:text-[14px]">
                    <span>(주)일신그룹 회장</span>
                    <span className="ml-[10px] text-[22px] font-[600] responsive1200:text-[14px]">김성년</span>
                </p>
                <hr className="my-9" />
                <div className="flex justify-between items-center mb-5 responsive650:flex-wrap responsive650:justify-start gap-[10px]">
                    <div className="flex-col w-[calc(50%-5px)]">
                        <img src={IntroDetail1} alt="introDetail1" className="responsive650:w-full" />
                        <div className="bg-[#333] text-[15px] w-full h-10 text-white flex items-center justify-center">
                            일신항공해운 본사
                        </div>
                    </div>
                    <div className="flex-col w-[calc(50%-5px)]">
                        <img src={IntroDetail2} alt="introDetail2" className="responsive650:w-full" />
                        <div className="bg-[#333] text-[15px] w-full h-10 text-white flex items-center justify-center">본사 물류센터</div>
                    </div>
                    <div className="flex-col w-[calc(50%-5px)]">
                        <img src={IntroDetail3} alt="introDetail3" className="responsive650:w-full" />
                        <div className="bg-[#333] text-[15px] w-full h-10 text-white flex items-center justify-center">
                            경기북부 물류센터
                        </div>
                    </div>
                    <div className="flex-col w-[calc(50%-5px)]">
                        <img src={IntroDetail4} alt="introDetail4" className="responsive650:w-full" />
                        <div className="bg-[#333] text-[15px] w-full h-10 text-white flex items-center justify-center">
                            일신항공해운 대구지사
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Introduction;
